import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';
import { linkifyText } from './linkify';
import './MobileLegalShell.css';

const APP_VERSION = '1.0.0';

export default function MobileLegalPrivacyPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('Privacy Policy');
  const [paragraphs, setParagraphs] = useState([]);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/settings/content/privacy-policy`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      setTitle(data.title || 'Privacy Policy');
      let list = [];
      try {
        list = JSON.parse(data.content || '[]');
      } catch {
        list = data.content ? [String(data.content)] : [];
      }
      if (Array.isArray(list) && list.length) {
        setParagraphs(list.map((p) => String(p)));
      } else {
        setParagraphs([data.description || 'We describe how we collect, use, store, and protect your information when you use our platform.']);
      }
    } catch {
      setTitle('Privacy Policy');
      setParagraphs([
        'We respect your privacy. This policy explains what information we collect (such as account details, device information, and how you use the app), how we use it to provide and improve services, and when we may share it with partners who assist our operations under strict agreements.',
        'You may access, update, or delete certain personal data through your account where applicable, and you can contact us for other privacy requests. We use reasonable security measures to protect your data, though no method of transmission over the internet is 100% secure.',
        'If you are in a region with specific data rights (e.g. access, portability, or deletion), you may exercise those rights as described in applicable law. We will respond within the time required by law.',
        'We may update this policy from time to time. The latest version will be shown in the app; material changes will be brought to your attention as required by law or as we reasonably deem appropriate.'
      ]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="mlegal-page">
      <header className="mlegal-header">
        <button type="button" className="mlegal-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mlegal-title mlegal-title--cap">{title}</h1>
      </header>
      <div className="mlegal-scroll">
        {loading ? (
          <p className="mlegal-loading">Loading…</p>
        ) : (
          <div className="mlegal-body mlegal-body--privacy">
            {paragraphs.map((p, idx) => (
              <p key={idx}>{linkifyText(p)}</p>
            ))}
          </div>
        )}
        <div className="mlegal-foot-version">V {APP_VERSION}</div>
      </div>
    </div>
  );
}
